import { render, staticRenderFns } from "./MdtTags.vue?vue&type=template&id=600dd582&scoped=true"
import script from "./MdtTags.vue?vue&type=script&lang=js"
export * from "./MdtTags.vue?vue&type=script&lang=js"
import style0 from "./MdtTags.vue?vue&type=style&index=0&id=600dd582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600dd582",
  null
  
)

export default component.exports